import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PathologyService } from 'src/app/pathology.service';
import { PatientsService } from 'src/app/patients.service';


@Component({
    selector: 'app-pathology-scan-popup',
    templateUrl: './pathology-scan-popup.component.html',
    styleUrls: ['./pathology-scan-popup.component.scss'],
    standalone: false
})
export class PathologyScanPopupComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @ViewChild('barcodeInputP') barcodeInputP!: ElementRef<HTMLInputElement>;

  exams: any[] = [];
  loading: boolean = false;
  examNames: string[] = [];

  scanning: boolean = false;
  pathologyScanning: number | null = null;
  barcodeInputPathology: string = '';

  constructor( private pathologyService: PathologyService, private patientsService: PatientsService) {}

  ngOnInit() {
    this.loadExamsAndPathologies();
  }

  async loadExamsAndPathologies() {
    this.loading = true;
    this.exams = [];
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    this.pathologyService.getTodayPathologies(this.patientsService.currentPatient.PID).subscribe((data: any) => {
      this.examNames = Object.keys(data);
      this.exams = data;
      this.loading = false;
    }, (error) => {
      this.exams = [];
      this.loading = false;
    });
   
  }


  scanExistingPathology(pathid: number) {
    this.pathologyScanning = pathid;
    this.scanning = true;
    this.barcodeInputPathology = '';
    setTimeout(() => {
      this.barcodeInputP?.nativeElement.focus();
    });
  }

  barcodeScanTimeout: any;

  onBarcodeInputChange() {
    if (this.barcodeScanTimeout) {
      clearTimeout(this.barcodeScanTimeout);
    }
    this.barcodeScanTimeout = setTimeout(() => {
      this.finishScan();
    }, 1000);
  }

  finishScan() {
    this.scanning = false;
    if (this.pathologyScanning != null && this.barcodeInputPathology) {
      this.pathologyService.updateBarcode(this.pathologyScanning, this.barcodeInputPathology).subscribe(() => {
        this.pathologyScanning = null;
        this.barcodeInputPathology = '';
        this.loadExamsAndPathologies();
      });
    } else {
      this.pathologyScanning = null;
      this.barcodeInputPathology = '';
    }
  }

  onScan(pathology: any) {
    this.scanExistingPathology(pathology.AutoIndex);
  }

  onClose() {
    this.close.emit();
  }
}
